import React from 'react'
import GoogleIcon from './GoogleIcon'

// TODO: Cuando termine la migración de GoogleIcon a Phosphor, eliminar el
// branch de string / GoogleIcon y dejar solo elemento o componente Phosphor.

export function isIconComponent(value) {
  if (value == null || typeof value === 'string' || React.isValidElement(value)) {
    return false
  }
  if (typeof value === 'function') return true
  return typeof value === 'object' && (typeof value.render === 'function' || value.$$typeof != null)
}

export function isGoogleIconName(value) {
  return typeof value === 'string' && value.length > 0
}

export function isPhosphorIconSource({ icon = null, iconNode = null } = {}) {
  return React.isValidElement(iconNode) || React.isValidElement(icon) || isIconComponent(icon)
}

export default function resolveIcon({
  icon = null,
  iconNode = null,
  googleName = null,
  size = 16,
  weight = 'regular',
  filled = false,
  className = ''
} = {}) {
  if (React.isValidElement(iconNode)) return iconNode
  if (React.isValidElement(icon)) return icon

  if (isIconComponent(icon)) {
    const Icon = icon
    return <Icon size={size} weight={weight} />
  }

  const name = isGoogleIconName(icon) ? icon : googleName
  if (!name) return null

  return <GoogleIcon name={name} size={size} filled={filled} className={className} />
}
